/* eslint-disable no-use-before-define */
// TODO(tom) it's going to take more work than just some lint
// changes to decouple these components.

/**
 * MarkerLegend is in charge of generating the legend (surprise!) for all
 * the markers. It is also in charge of placing that legend on the map.
 *
 * You can get the filters that are currently selected by the user by
 * calling window.batchGeoGoogleMapsMarker.MarkerLegend.getFilters()
 * If you need to apply a filter(s), you can do so with the setter
 * window.batchGeoGoogleMapsMarker.MarkerLegend.setFilters(filtersArray)
 *
 */
(function () {
  var MarkerLegend = function () {
    var self = this;
    var column = ""; // currently selected column
    var columns = []; // columns capable of grouping by
    var groups = []; // groups in current set
    var filters = []; // array of active filters
    var legendFilteredMarkers = {}; // markers currently enabled using filters
    var wrap = $("#legWrap");
    var elem = wrap.find("#legDiv");
    var mapDiv = $("#mapDiv");
    var selectedCountEl = $("<button />", {
      addClass: "selected-marker-count",
      mousedown: (e) => {
        e.stopPropagation();
      },
      click: (e) => {
        e.stopPropagation();
        window.batchGeoGoogleMapsMarker.MarkerInfoWindow.close();
        $(window).trigger("batchgeo.drawingmanager.clearMap");

        BatchGeoStore.dispatch({
          type: "ROW_SELECT_SELECT",
          selectedRows: [],
        });
      },
    });
    // var selectedColors = [];
    var leftItem;
    // var rightItem;
    var timeout = false;
    var delay = 250;
    var metric = "km"; //km by default
    var previousSelectedColumnIndex = window.per.group_col;
    const DISTANCE_COLUMN_NAME = "Distance Between Points";

    /**
     * Builds and injects the results section of the marker legend. That's
     * the part that says like "2 locations found" with the little X button
     * that clears all filters.
     *
     * It will make sure that this element doesn't already exist and if so
     * it will destroy it before putting a new one in the DOM.
     * @return {undefined}
     */

    var getDelay = function () {
      return delay;
    };

    var getTimeoutValue = function () {
      return timeout;
    };

    var setTimeoutValue = function (value) {
      timeout = value;
    };

    var getMetricValue = function () {
      return metric;
    };

    var setMetricValue = function (value) {
      metric = value;
    };

    var isActive = function () {
      return (
        $("#legWrap").length > 0 && $("#legWrap")[0].style.display !== "none"
      );
    };

    var updateFilterResults = function () {
      var markerLegendState = BatchGeoStore.getState().MarkerLegend;
      var $resultsCache = updateFilterResults.$results;
      var filteredMarkerCount = markerLegendState.filteredMarkers.length;

      // If there's already $results we need to remove the old one before
      // we add the new one
      if ($resultsCache !== undefined && $resultsCache.length) {
        $resultsCache.remove();
      }

      var $results = $("<div />", {
        class: "listCount",
        html: [
          // The little X close button
          $("<span />", {
            class: "listCountCloseButton",
            click: clearFilters,
          }),
          // Shows the total count of the markers
          $("<p />", {
            text: BatchGeo.pluralize(filteredMarkerCount, "Location"),
          }),
          $("<div />", {
            class: "listCountDivider",
          }),
        ],
      });

      BatchGeoStore.dispatch({
        type: "MARKER_LEGEND_CACHE_DOM",
        $results: $results,
      });

      BatchGeoStore.getState().MarkerLegend.$list.before($results);
    };

    var filterColumns = function (redo) {
      if (typeof self.options.markersData.legend_columns !== "undefined") {
        columns = self.options.markersData.legend_columns;
      }
      redo = typeof redo !== "undefined" ? redo : false;

      if (!redo && columns.length) return;
      columns = [];

      BatchGeo.timer("update group by columns");

      // loop each column to decide whether to make it a group-by option
      for (var i = 0; i < self.options.markersData.columnNames.length; i++) {
        var pVal = ""; // stores each value - "previous value"
        var hasDistinct = false; // does this column have more than one value?
        var numberCol = true; // is this a column full of numbers?
        var allUnique = false; // every value is distinct
        var noneUnique = false; // every value is identical
        var allValues = []; // all values in this column
        var valueCounts = {}; // counts of individual distinct values
        var distinctCount = 0; // total number of distinct values
        var pctDistinct = 0; // percentage of all values that are distinct
        let partialUnique = false; //depends on the percentage, the values are partially distinct.
        var assignedToOther = columnIsAssigned(i); // is this column used in mapRS?

        if (
          self.options.markersData.columnNames[i]
            .toLowerCase()
            .indexOf("phone") > -1
        )
          continue; // skip phone numbers

        if (!assignedToOther) {
          // populate the array of values and increment counters of distinct values
          for (var mDD in self.options.markersData.dataRS) {
            var mDDval = BatchGeo.toStr(
              self.options.markersData.dataRS[mDD][i],
            );
            if (mDDval !== "") {
              allValues.push(mDDval);
              if (valueCounts[mDDval] !== undefined) {
                valueCounts[mDDval]++;
              } else {
                valueCounts[mDDval] = 1;
              }
            }
          }

          // count the distinct values
          for (var mV in self.options.markersData.dataRS) {
            var mVVal = BatchGeo.toStr(self.options.markersData.dataRS[mV][i]);
            if (valueCounts[mVVal] == 1) {
              distinctCount++;
            }
          }

          if (distinctCount === allValues.length) allUnique = true;

          if (Object.keys(valueCounts).length === 1) noneUnique = true;

          const partialUniqueThreshold = allValues.length > 1000 ? 20 : 50;

          pctDistinct = (distinctCount / allValues.length) * 100;

          if (pctDistinct >= partialUniqueThreshold) partialUnique = true;

          for (var mD in self.options.markersData.dataRS) {
            var row = self.options.markersData.dataRS[mD];
            var val = BatchGeo.toStr(row[i]);

            if (val !== undefined && val !== null) {
              if (!hasDistinct) {
                if (pVal == val) {
                  // this value is the same as the previous
                } else {
                  // this value is different from previous
                  hasDistinct = true;
                }
              }

              // turn parens into negative number
              if (val.charAt(0) == "(" && val.charAt(val.length - 1) == ")") {
                let valTest = val.substring(1);
                valTest = valTest.substring(0, valTest.length - 1);
                if (BatchGeo.isNumber(valTest)) {
                  // removed first and last char (parens) and found that it created a number
                  // so make it negative
                  if (!(valTest.charAt(0) == "-")) {
                    val = "-" + valTest;
                    self.options.markersData.dataRS[mD][i] = val;
                  }
                }
              }
              if (val.charAt(0) == "-" && val.charAt(1) == "$") {
                val = "-" + val.slice(2);
                self.options.markersData.dataRS[mD][i] = val;
              }

              // only do isNumber() if we still think this might be a number-only column
              if (numberCol && !BatchGeo.isNumber(val)) {
                numberCol = false;
              }

              // bail out if we've learned everything
              if (hasDistinct && !allUnique && !numberCol) {
                break;
              }

              pVal = val; // set the "previous value"
            }
          } // end foreach row of data
        } // end if !assignedToOther
        if (
          (hasDistinct && !assignedToOther && !allUnique) ||
          (hasDistinct && !assignedToOther && allUnique && numberCol) ||
          self.options.markersData.group_col === i
        ) {
          if (
            (self.options.markersData.group_col > -1 &&
              !noneUnique &&
              !partialUnique) ||
            (self.options.markersData.group_col > -1 &&
              !noneUnique &&
              numberCol)
          ) {
            columns.push(i);
          }
        }
      } // end for self.options.markersData.columnNames

      // if we have a group_col selected in map settings
      // and the group_col is not in the columns, add it
      if (
        self.options.markersData.group_by_sel > -1 &&
        columns.indexOf(Number(self.options.markersData.group_by_sel)) < 0
      ) {
        columns.push(self.options.markersData.group_by_sel);
      }

      const distIndex = window.getDistanceColumnIndex();
      if (
        self.options.markersData.dist_cb_status &&
        distIndex !== -1 &&
        columns.indexOf(distIndex) === -1
      ) {
        columns.push(distIndex);
      }

      return columns;
    };

    var moveBackward = function () {
      var temp_start = window.batchGeoGoogleMapsMarker.startValue;
      var temp_stop = window.batchGeoGoogleMapsMarker.stopValue;
      var markerScaler = window.batchGeoGoogleMapsMarker.markerScaler;

      if (temp_start !== 0) {
        if (temp_stop % markerScaler !== 0) {
          var offset = temp_stop % markerScaler;
          temp_stop = temp_stop - offset;
          temp_start = temp_start - markerScaler;
        } else {
          temp_start = temp_start - markerScaler;
          temp_stop = temp_stop - markerScaler;
        }

        window.batchGeoGoogleMapsMarker.startValue = temp_start;
        window.batchGeoGoogleMapsMarker.stopValue = temp_stop;
        window.batchGeoGoogleMapsMarker.MarkerGroups.buildGroups();
        updatePolylineColors();
        updateGroupList();
        update(true, false);
        window.reorderGroups(true, 5);
        updateActiveMarkerIcon(true, true);
      }
    };

    var moveForward = function () {
      var temp_start = window.batchGeoGoogleMapsMarker.startValue;
      var temp_stop = window.batchGeoGoogleMapsMarker.stopValue;
      // var markerScaler = window.batchGeoGoogleMapsMarker.markerScaler;
      var limit = window.batchGeoGoogleMapsMarker.limit;

      if (temp_stop !== limit) {
        temp_start = temp_stop;
        temp_stop = temp_start + window.batchGeoGoogleMapsMarker.markerScaler;

        if (temp_stop > limit) {
          const offset = temp_stop - limit;
          temp_stop = temp_stop - offset;
          //reset start spot
        }
        window.batchGeoGoogleMapsMarker.startValue = temp_start;
        window.batchGeoGoogleMapsMarker.stopValue = temp_stop;

        //repopulate groups
        window.batchGeoGoogleMapsMarker.MarkerGroups.buildGroups();
        updatePolylineColors();
        updateGroupList();
        update(true, false);
        window.reorderGroups(true, 4);
        updateActiveMarkerIcon(true, true);
      }
    };

    var updatePolylineColors = function () {
      let heatedColorPallet = self.options.heatColors;
      // TODO(tom) why do we have this if we don't use it? Make me nervous that it's supposed to be
      // updating OTHER distanceMode references in this file
      // let distanceMode = false;
      // if(window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME){
      //   distanceMode = true;
      // }
      //update the current polylines in use
      let listOfPolylines = window.batchGeoTableMap?.listForDispatch;
      //let polylines = window.batchGeoTableMap?.listForDispatch;

      //current map
      let map = window.batchGeoGoogleMapsManager.getMap();
      //if there are no polylines or no map, then dont bother
      if (listOfPolylines && map) {
        //all markers should have had their colors updated by the buildGroups function
        //now we need to update the polylines associated with those markers to
        //to reflect the new color if there is one.
        //update the color of polyline based on start locations id [polyline.startId] -> which is its index in mapRS/dataRS
        //the clr is mapped to a color string, and is further mapped to a hex which will be used to updated the strokeColor.

        listOfPolylines.forEach((polyline) => {
          // we need to differentiate here if we should be looking at the color pallet
          let colorIndex;
          colorIndex = heatedColorPallet.indexOf(
            window.batchGeoTableMap.batchGeoTable.options.data.mapRS[
              polyline.startId
            ].heatClr,
          );

          if (colorIndex < 0) return;
          // we need to differentiate here if we should be looking at the color pallet

          let rowColor;
          rowColor = "#" + window.heatHexArray[colorIndex];

          polyline.polyline.setOptions({ strokeColor: rowColor });

          //update the map for this polyline
          //only show polylines that have not been filtered out...
          let startLocations = listOfPolylines.map(
            (polyline) => polyline.startId,
          );
          var map = window.batchGeoGoogleMapsManager.getMap();

          let activeMarkersObject = filters.reduce(function (acc, filter) {
            var markerIds = Object.keys(filter.markers).map(function (id) {
              return parseInt(id);
            });
            acc[filter.column] = acc[filter.column]
              ? acc[filter.column].concat(markerIds)
              : markerIds;
            return acc;
          }, {});

          let twoDActiveSet = [];
          for (let q = 0; q < Object.keys(activeMarkersObject).length; q++) {
            let activeMarkersKey = Object.keys(activeMarkersObject)[q]; // gets the key for the current filter
            twoDActiveSet.push(activeMarkersObject[activeMarkersKey]);

            let shared = getSharedValues(twoDActiveSet);
            if (shared != undefined) {
              startLocations.forEach((location, index) => {
                if (shared.indexOf(location) !== -1) {
                  listOfPolylines[index].polyline.setMap(map);
                } else {
                  listOfPolylines[index].polyline.setMap(null);
                }
              });
            } else {
              startLocations.forEach((location, index) => {
                listOfPolylines[index].polyline.setMap(map);
              });
            }
          }
          if (twoDActiveSet.length == 0) {
            startLocations.forEach((location, index) => {
              listOfPolylines[index].polyline.setMap(map);
            });
          }
        });
      }
    };

    var updateActiveMarkerIcon = function (toggleValue, clear = false) {
      // var toggleValue = toggleValue;
      // var clear = clear || false;

      var $listWrap = $('<div class="filterListWrap wrapView">');
      BatchGeoStore.dispatch({
        type: "MARKER_LEGEND_CACHE_DOM",
        $listWrap: $listWrap,
      });

      let activeMarkerCount = BatchGeoStore.getState().RowSelect;

      if (toggleValue && clear) {
        const filterListWrap = elem.find(".filterListWrap");
        if (!filterListWrap.length && activeMarkerCount.selection.length > 0) {
          elem.append($listWrap);
        }
      }

      if (activeMarkerCount && activeMarkerCount.selection && clear) {
        const filterListWrap = elem.find(".filterListWrap");
        const filters = BatchGeoStore.getState().MarkerLegend.filters;
        if (
          !activeMarkerCount.selection.length &&
          !filters.length &&
          filterListWrap.length
        ) {
          filterListWrap.remove();
        }
      }
    };

    var syncFilterAndSelectedMarkers = function () {
      if (!window.batchGeoTableMap) {
        return;
      }
      const filteredMarkers = getFilteredMarkers();
      const rowSelector = window.batchGeoTableMap.batchGeoTable.RowSelect;
      const selectedRows = rowSelector.getSelectedRows();
      const filteredOutRowIds = selectedRows
        .filter((row) => !filteredMarkers[row.id])
        .map((row) => row.id);
      rowSelector.deselect(filteredOutRowIds);
    };

    var resizeColumnListHeight = function () {
      var $columnList = elem.find(".columnList");

      // Reset to default height in case something else had changed it already
      $columnList.height("");
      // Get the heights AFTER the heights have been reset
      var columnListHeight = elem.find(".columnList").outerHeight() + 100;
      var mapDivHeight = $("#mapDiv").outerHeight();

      if (columnListHeight > mapDivHeight) {
        $columnList.height(mapDivHeight - 125).addClass("overflowColumnList");
      } else {
        $columnList.removeClass("overflowColumnList");
      }
    };

    var resizeWrap = function () {
      // Actually resizes and repositions a host of related map
      // elements. Not sure if this is the right way or overkill:
      window.batchGeoMap.bgSize(true);
      resizeColumnListHeight();
    };

    var updateFilterList = function () {
      var $listWrap = $('<div class="filterListWrap">');
      var $list = $('<ul class="filterList">');
      let distanceMode = false;
      if (
        window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
      ) {
        distanceMode = true;
      }

      BatchGeoStore.dispatch({
        type: "MARKER_LEGEND_CACHE_DOM",
        $listWrap: $listWrap,
        $list: $list,
      });

      var clickRemove = function () {
        var resize = false;
        if (filters.length == 1) resize = true; // resize since this is the only filter and will drop some height when its gone
        var groupValue = $(this).attr("group");
        var columnValue = $(this).attr("column");
        removeFilter($(this).attr("column"), $(this).attr("group"));
        if (columnValue === DISTANCE_COLUMN_NAME) {
          //remove them from whatever is tracking this
          self.MarkerGroups.heatColorObjectsInUse =
            self.MarkerGroups.heatColorObjectsInUse.filter((color) => {
              var value_location =
                self.MarkerGroups.heatFilterGroups.indexOf(groupValue);

              var colorToRemove =
                self.MarkerGroups.heatColorObjectsInUse[value_location]
                  .location;

              return (
                color.column !== columnValue || color.location !== colorToRemove
              );
            });
          self.MarkerGroups.heatFilterGroups.splice(
            self.MarkerGroups.heatFilterGroups.indexOf(groupValue),
            1,
          );
        } else {
          self.MarkerGroups.colorObjectsInUse =
            self.MarkerGroups.colorObjectsInUse.filter((color) => {
              var value_location =
                self.MarkerGroups.filterGroups.indexOf(groupValue);
              if (value_location == -1) {
                return color.location !== -1;
              } else {
                var noSearchColors = self.MarkerGroups.colorObjectsInUse.filter(
                  (color) => color.location >= 0,
                );
                var colorToRemove = noSearchColors[value_location].location;
                return (
                  color.column !== columnValue ||
                  color.location !== colorToRemove
                );
              }
            });
        }

        self.MarkerGroups.filterGroups = self.MarkerGroups.filterGroups.filter(
          (item) => {
            return item !== groupValue;
          },
        );
        var colorIndex = groups.indexOf(groupValue);
        if (
          self.MarkerGroups.filterGroups.length == 0 &&
          colorIndex !== undefined &&
          self.getMarkerGroupsArray()[colorIndex] !== undefined
        ) {
          if (columnValue === DISTANCE_COLUMN_NAME) {
            if (groupValue === "(Unselected Markers)") {
              self.getMarkerGroupsArray()[colorIndex].clr = "grey";
            } else {
              self.getMarkerGroupsArray()[colorIndex].clr =
                self.options.heatColors[colorIndex];
            }
          } else if (
            window.per.isThematic &&
            !window.per.disablethematic_cb &&
            !window.per.isCurrentThematicMarkerGroupDate
          ) {
            self.getMarkerGroupsArray()[colorIndex].clr =
              window.per.thematicColors[colorIndex];
          } else {
            self.getMarkerGroupsArray()[colorIndex].clr =
              window.per.colors[colorIndex];
          }
        }
        updatePolylineColors();
        update(true, false);
        if (resize) resizeWrap();
      };

      let offset = 0;
      let heatOffset = 0;

      for (var i = 0; i < filters.length; i++) {
        var item;
        if (filters[i].column == DISTANCE_COLUMN_NAME) {
          offset -= 1;
        } else {
          heatOffset -= 1;
        }
        if (
          filters[i].column !==
          self.options.markersData.columnNames[
            self.options.markersData.group_col
          ]
        ) {
          // condition the color of the background relative to whether or not this is part of the group.
          item = $(
            "<li>" + filters[i].column + ": " + filters[i].group + "</li>",
          ) /*.attr("style", 'background-color: #' + window.hexArray[self.MarkerGroups.colorIndiciesInUse[i]])*/
            .attr("column", filters[i].column)
            .attr("group", filters[i].group);
        } else {
          if (distanceMode) {
            if (filters[i].group === "(Unselected Markers)") {
              item = $(
                "<li>" + filters[i].column + ": " + filters[i].group + "</li>",
              )
                .attr("style", "background-color: #808080")
                .attr("column", filters[i].column)
                .attr("group", filters[i].group);
            } else {
              item = $(
                "<li>" + filters[i].column + ": " + filters[i].group + "</li>",
              )
                .attr(
                  "style",
                  "background-color: #" +
                    window.heatHexArray[
                      self.MarkerGroups.heatColorObjectsInUse[i + heatOffset]
                        .location
                    ],
                )
                .attr("column", filters[i].column)
                .attr("group", filters[i].group);
            }
          } else if (
            window.per.isThematic &&
            !window.per.disablethematic_cb &&
            !window.per.isCurrentThematicMarkerGroupDate
          ) {
            item = $(
              "<li>" + filters[i].column + ": " + filters[i].group + "</li>",
            )
              .attr(
                "style",
                "background-color: #" +
                  window.thematicHexArray[
                    self.MarkerGroups.colorObjectsInUse[i + offset].location
                  ],
              )
              .attr("column", filters[i].column)
              .attr("group", filters[i].group);
          } else {
            if (self.MarkerGroups.colorObjectsInUse.length > 0) {
              if (filters[i].location == -1) {
                continue;
              }
              item = $(
                "<li>" + filters[i].column + ": " + filters[i].group + "</li>",
              )
                .attr(
                  "style",
                  "background-color: #" +
                    window.hex[
                      self.MarkerGroups.colorObjectsInUse[i + offset]?.location
                    ],
                )
                .attr("column", filters[i].column)
                .attr("group", filters[i].group);
            }
          }
        }
        if (item) {
          item.click(clickRemove);
        }
        /*
        item.css({
          backgroundColor: self.getMarkerGroupsArray()[i].clr
        })
        */
        $list.append(item);
      }

      elem.find(".filterListWrap").remove();

      if (filters.length) {
        elem.append($listWrap);
        $listWrap.append($list);

        if (!document.getElementById("preview")) {
          var prevH = $("#mapDiv").height();
          $("#mapDiv").css("height", prevH - $($listWrap).outerHeight() - 5);
        }

        updateFilterResults();
        updateActiveMarkerIcon(true);
      }
    };

    var hideWrap = function () {
      if (!wrap.height()) {
        wrap.hide();
        if (!document.getElementById("preview")) {
          $("#mapDiv").css(
            "height",
            $(window).height() - $("#topBar").outerHeight(),
          );
        }
      }
    };

    var updateColumnName = function () {
      if (
        self.options.markersData.group_by_sel < 0 &&
        !self.options.markersData.dist_cb_status
      )
        return;

      column =
        self.options.markersData.columnNames[
          self.options.markersData.group_col
        ] || self.options.distance_str;

      var div =
        '<div class="columnWrap"><div class="columnName">' +
        column +
        "</div></div>";
      elem.find(".columnWrap").remove();
      elem.append(div);
    };

    var selectColumn = function (col, redraw = false, buildGroups = false) {
      const currentColumnName = self.options.markersData.columnNames[col];
      if (currentColumnName !== DISTANCE_COLUMN_NAME) {
        previousSelectedColumnIndex = col;
      }

      // redraw = typeof redraw !== 'undefined' ? redraw : false;
      BatchGeo.timer(
        `legend selectColumn() ${col} - ${redraw} - ${buildGroups}`,
      );

      if (col > -1) {
        self.options.markersData.group_col = col;
        for (var i = 0; i < self.options.markersData.mapRS.length; i++) {
          if (typeof self.options.markersData.dataRS[i] != "undefined") {
            if (
              self.options.markersData.mapRS[i].g !=
              self.options.markersData.dataRS[i][
                self.options.markersData.group_col
              ]
            ) {
              var groupValue =
                self.options.markersData.dataRS[i][
                  self.options.markersData.group_col
                ];
              self.options.markersData.mapRS[i].g =
                groupValue && typeof groupValue === "string"
                  ? groupValue.trim()
                  : groupValue || "";
            }
          }
        }

        // group by column changed, refresh map
        self.MarkerGroups.resetValues();

        // if redraw is valid, allow next block of code to handle buildGroups.
        // no point in calling it twice.
        if (buildGroups && !redraw) {
          self.MarkerGroups.buildGroups();
        }

        if (redraw) {
          self.MarkerGroups.buildGroups();
          updateFilterList();
          updatePolylineColors();
          update(redraw);
          updateActiveMarkerIcon(true, true);
        }
      }
    };

    var updateColumnList = function () {
      if (
        self.options.markersData.group_col < 0 &&
        !self.options.markersData.dist_cb_status
      )
        return;
      if (columns.length <= 1 || self.options.markersData.group_by_sel == -1)
        // only one groupable column, remove drop down select box
        $("#legDiv .columnWrap").addClass("no-menu");

      if (column != "Group" && columns.length < 2) return;

      var list = $('<ul class="columnList">');
      var itemClick = function (e) {
        selectColumn(e.target.id, true);
        e.preventDefault();
        return false;
      };

      for (var i = 0; i < columns.length; i++) {
        var item = $(
          '<li id="' +
            columns[i] +
            '">' +
            self.options.markersData.columnNames[columns[i]] +
            "</li>",
        );
        item.click(itemClick);
        list.append(item);
      }

      elem.find(".columnList").remove();
      elem.find(".columnName").append(list);

      if (!BatchGeoDevices.is("mobile"))
        $("#legDiv .columnWrap").click(window.mapReset);
    };

    var filterExists = function (column_, group_) {
      for (var i = 0; i < filters.length; i++) {
        if (filters[i].column == column_ && filters[i].group == group_) {
          return true;
        }
      }
      return false;
    };

    /**
     * Returns an icon to be used for the legend in the form of an SVG Data URL
     * @param {string} color The color to use for the icon
     * @returns {string} An SVG Data URL string
     */
    var getLegendIcon = function (color) {
      return BatchGeoSvgMarkerIcon({
        type: self.options.markersData.shape + "Plain",
        template: {
          height: { pushpin: 34, circle: 20, square: 24 }[
            self.options.markersData.shape
          ],
          width: 20,
          fill: color,
        },
      }).url;
    };

    var selectGroup = function (groupName, redraw) {
      var markerShortcut = self.options.markersData.mapRS;
      redraw = typeof redraw !== "undefined" ? redraw : false;
      var repopulate = false;
      let distanceMode = false;
      if (
        window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
      ) {
        distanceMode = true;
      }
      groupName = groupName.trim() || "&nbsp;"; // special case blank group names
      // if color index is inside of the colorIndiciesInUse, we need to select a new u
      var location = groups.indexOf(groupName);
      var real = groups.indexOf(groupName);
      if (filterExists(column, groupName)) {
        removeFilter(column, groupName);
        if (distanceMode) {
          self.MarkerGroups.heatColorObjectsInUse =
            self.MarkerGroups.heatColorObjectsInUse.filter((color) => {
              var value_location =
                self.MarkerGroups.heatFilterGroups.indexOf(groupName);

              var colorToRemove =
                self.MarkerGroups.heatColorObjectsInUse[value_location]
                  .location;
              return (
                color.column !== column || color.location !== colorToRemove
              );
            });
          self.MarkerGroups.heatFilterGroups.splice(
            self.MarkerGroups.heatFilterGroups.indexOf(groupName),
            1,
          );
        } else {
          self.MarkerGroups.colorObjectsInUse =
            self.MarkerGroups.colorObjectsInUse.filter((color) => {
              var value_location =
                self.MarkerGroups.filterGroups.indexOf(groupName);
              if (value_location == -1) {
                return color.location !== -1;
              } else {
                var noSearchColors = self.MarkerGroups.colorObjectsInUse.filter(
                  (color) => color.location >= 0,
                );
                var colorToRemove = noSearchColors[value_location].location;
                return (
                  color.column !== column || color.location !== colorToRemove
                );
              }
            });
        }
        self.MarkerGroups.filterGroups = self.MarkerGroups.filterGroups.filter(
          (item) => {
            return item !== groupName;
          },
        );

        if (
          self.MarkerGroups.colorObjectsInUse.length == 0 ||
          self.MarkerGroups.heatColorObjectsInUse.length == 0
        ) {
          repopulate = true;
        }
      } else {
        if (self.MarkerGroups.filterGroups.length < 10) {
          var runner = 0;
          if (
            window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
          ) {
            distanceMode = true;
          }
          while (
            self.MarkerGroups.colorObjectsInUse.filter(
              (color) => color.location === location && color.column === column,
            ).length &&
            runner < 9
          ) {
            if (
              self.MarkerGroups.colorObjectsInUse.filter(
                (color) =>
                  color.location === location && color.column === column,
              ).length
            ) {
              location++;
            }
            if (location == window.colorPallet.length) {
              location = 0;
            }
            runner++;
          }
          var found = false;
          var count = 0;

          // need to check that the value that we just picked is a valid selection?
          // i.e. 3 filters selected, page to last page, 3 filters availble, selecting any value will give location 3...
          // which is out of bounds for this page

          while (
            count < 10 &&
            self.MarkerGroups.filterGroups.length < window.colorPallet.length &&
            location <
              window.colorPallet
                .length /* && self.MarkerGroups.colorObjectsInUse.filter(color => color.location === window.colorPallet.indexOf(self.getMarkerGroupsArray()[location].clr)).length*/
          ) {
            //check for the matching object
            for (
              let q = 0;
              q < self.MarkerGroups.colorObjectsInUse.length;
              q++
            ) {
              if (self.MarkerGroups.colorObjectsInUse[q].location == location) {
                // we have the same index
                if (self.MarkerGroups.colorObjectsInUse[q].column == column) {
                  found = true;
                }
              }
            }
            if (found) {
              location++;
              if (location == window.colorPallet.length) {
                location = 0;
              }
            }
            count++;
          }
          if (distanceMode) {
            location = groups.indexOf(groupName);
            real = groups.indexOf(groupName);

            if (groupName === "(Unselected Markers)") {
              self.getMarkerGroupsArray()[real].clr = "grey";
            } else {
              self.getMarkerGroupsArray()[real].clr =
                self.options.heatColors[location];
            }
          } else if (
            window.per.isThematic &&
            !window.per.disablethematic_cb &&
            !window.per.isCurrentThematicMarkerGroupDate
          ) {
            location, (real = groups.indexOf(groupName));
            self.getMarkerGroupsArray()[real].clr =
              window.per.thematicColors[location];
          } else {
            self.getMarkerGroupsArray()[real].clr = window.per.colors[location];
          }

          let tempArray = self.getMarkerGroupsArray()[real].all;

          if (distanceMode) {
            if (groupName === "(Unselected Markers)") {
              for (let item in tempArray) {
                markerShortcut[item].clr = "grey";
              }
            } else {
              for (let item in tempArray) {
                markerShortcut[item].clr = self.options.heatColors[location];
              }
            }
          } else if (
            window.per.isThematic &&
            !window.per.disablethematic_cb &&
            !window.per.isCurrentThematicMarkerGroupDate
          ) {
            for (let item in tempArray) {
              markerShortcut[item].clr = window.per.thematicColors[location];
            }
          } else {
            for (let item in tempArray) {
              markerShortcut[item].clr = window.per.colors[location];
            }
          }

          createFilter(
            column,
            groupName,
            self.getMarkerGroupsArray()[real].all,
          );

          if (distanceMode) {
            if (
              !self.MarkerGroups.heatColorObjectsInUse.filter(
                (color) => color.location === location,
              ).length
            ) {
              const colorObj = {
                location: location,
                column: column,
              };
              self.MarkerGroups.heatColorObjectsInUse.push(colorObj);
            }
          } else {
            if (
              !self.MarkerGroups.colorObjectsInUse.filter(
                (color) => color.location === location,
              ).length
            ) {
              const colorObj = {
                location: location,
                column: column,
              };
              self.MarkerGroups.colorObjectsInUse.push(colorObj);
            } else {
              var temp = location;

              var counnt = 0;
              while (
                counnt < 10 &&
                self.MarkerGroups.colorObjectsInUse.filter(
                  (color) => color.location === temp,
                ) &&
                temp < window.colorPallet.length &&
                self.MarkerGroups.colorObjectsInUse.length <
                  window.colorPallet.length
              ) {
                temp++;
                if (temp == window.colorPallet.length) {
                  temp = 0;
                }
                counnt++;
              }
              var colorObj = {
                location: temp,
                column: column,
              };
              self.MarkerGroups.colorObjectsInUse.push(colorObj);
            }
          }
          if (distanceMode) {
            self.MarkerGroups.heatFilterGroups.push(groupName);
          } else {
            self.MarkerGroups.filterGroups.push(groupName);
          }
        }
      }

      if (repopulate) {
        if (distanceMode) {
          //what is location:
          if (groupName === "(Unselected Markers)") {
            self.getMarkerGroupsArray()[real].clr = "grey";
          } else {
            self.getMarkerGroupsArray()[location].clr =
              self.options.heatColors[location];
          }
        } else if (
          window.per.isThematic &&
          !window.per.disablethematic_cb &&
          !window.per.isCurrentThematicMarkerGroupDate
        ) {
          self.getMarkerGroupsArray()[location].clr =
            window.per.thematicColors[location];
        } else {
          self.getMarkerGroupsArray()[location].clr =
            window.per.colors[location];
        }
      }

      let polylines = window.batchGeoTableMap?.listForDispatch;

      if (polylines) {
        // let rowIds = BatchGeoStore.getState().RowSelect.selection;
        // let filteredMarkers = BatchGeoStore.getState().MarkerLegend
        let startLocations = polylines.map((polyline) => polyline.startId);
        var map = window.batchGeoGoogleMapsManager.getMap();

        let activeMarkersObject = filters.reduce(function (acc, filter) {
          var markerIds = Object.keys(filter.markers).map(function (id) {
            return parseInt(id);
          });
          acc[filter.column] = acc[filter.column]
            ? acc[filter.column].concat(markerIds)
            : markerIds;
          return acc;
        }, {});

        // need to create a set of markers that belong all filter groups
        let twoDActiveSet = [];
        for (let q = 0; q < Object.keys(activeMarkersObject).length; q++) {
          let activeMarkersKey = Object.keys(activeMarkersObject)[q];
          twoDActiveSet.push(activeMarkersObject[activeMarkersKey]);
        }
        let shared = getSharedValues(twoDActiveSet);
        if (shared != undefined) {
          startLocations.forEach((location, index) => {
            if (shared.indexOf(location) !== -1) {
              polylines[index].polyline.setMap(map);
            } else {
              polylines[index].polyline.setMap(null);
            }
          });
        } else {
          startLocations.forEach((location, index) => {
            polylines[index].polyline.setMap(map);
          });
        }
      }
      update(redraw, false);
    };

    var updateGroupList = function () {
      if (
        self.options.markersData.group_col < 0 &&
        !self.options.markersData.dist_cb_status
      )
        return;

      var leftStart = self.startValue;
      var endValue = self.limit - self.stopValue;
      var list;

      if (leftStart == 0) {
        list = $('<ul class="firstPage groupList itemlist">');
      } else {
        list = $('<ul class="groupList itemlist">');
      }

      var greyUrl = "../../images/gray-marker.png";

      var itemClick = function () {
        selectGroup($(this).text(), true);
        return false;
      };

      groups = [];
      self.options.markersData.shape =
        self.options.markersData.shape || "pushpin";
      if (leftStart !== 0) {
        leftItem = $(
          '<li class="leftItem" id="targetItemFront"> (' +
            leftStart +
            ") </li>",
        );
        leftItem.css({
          height: "20px",
          width: "auto",
          backgroundImage: !self.MarkerGroups.filterGroups.length
            ? "url(" +
              getLegendIcon(window.per.colors[window.per.colors.length - 1]) +
              ")"
            : "url(" + greyUrl + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize:
            self.options.markersData.shape == "pushpin" ? "14px" : "17px",
          backgroundPosition: "0px 0px",
          textDecoration: "none",
          paddingLeft: "20px",
          margin: "2px 12px 5px 25px",
          lineHeight: "20px",
          listStyleType: "none",
          gridColumn: "3/4",
          position: "relative",
        });
        leftItem.click(moveBackward);

        list.prepend(leftItem);
      }

      for (var i = 0; i < self.getMarkerGroupsArray().length; i++) {
        if (self.getMarkerGroupsArray()[i]) {
          var name =
            (self.getMarkerGroupsArray()[i].name.trim &&
              self.getMarkerGroupsArray()[i].name.trim()) ||
            "(No Value Provided)"; // special case blank group names
          // in the case of 'distance between points' adjust the column name
          if (
            name === "(No Value Provided)" &&
            column === "Distance Between Points"
          )
            name = "(Unselected Markers)";
          var item;

          if (name == "Others") {
            item = $("<li> (" + endValue + ") </li>");
          } else {
            item = $("<li>" + name + "</li>");
          }
          if (
            name !== item.text() &&
            !["(No Value Provided)", "(Unselected Markers)", "Others"].includes(
              name,
            )
          ) {
            name = item.text();
          }

          groups[i] = name;

          item.attr("title", "Toggle filtering for this grouping");
          // The single quotes wrapping the data URL are important! Double quotes
          // and no quotes will make it so the icon does not display
          item.css({
            backgroundImage:
              "url('" +
              getLegendIcon(self.getMarkerGroupsArray()[i].clr) +
              "')",
            backgroundRepeat: "no-repeat",
            backgroundSize:
              self.options.markersData.shape == "pushpin" ? "14px" : "17px",
            backgroundPosition: "0 0px",
            textDecoration: "none",
            display: "flex",
            order: "0",
          });

          if (name !== "Others") {
            item.click(itemClick);
          } else {
            item.click(moveForward);
          }

          if (filterExists(column, name)) item.addClass("active");
          //Todo: strike through non valid group by filter
          // if a filter exists, then at li gets the class.
          // however if a filter does exist from another column and switch
          // then the filter wont exist (so we dont get the active class)
          // however the condition following this will pass.
          // in doing so, the options that are availble are still grey, but
          // the ones that are not get a strike through

          if (filters.length) {
            var atLeast1 = false; // is there at least one marker existing on the map from this group
            var addToLeft = false;
            for (var c in self.getMarkerGroupsArray()[i].all) {
              if (
                self.getMarkerGroupsArray()[i].all[c] &&
                legendFilteredMarkers[c]
              ) {
                atLeast1 = true;
                break;
              }
            }
            if (!atLeast1) {
              // just add it once.
              if (addToLeft == false && leftStart !== 0) {
                addToLeft = true;
                leftItem.addClass("inactive");
              }
              item.addClass("inactive");
              item.css({
                //grey out the rest of the marker colors
                //this can be normalized once the svg is created
                backgroundImage: "url(" + greyUrl + ")",
              });
            }
          }
          if (name == "Others") {
            item.attr("id", "targetItem");
          }

          if (endValue == 0) {
            if (name !== "Others") list.append(item);
          } else {
            list.append(item);
          }
        }
      }

      elem.find(".groupList").remove();
      if (groups.length) {
        elem.append(list);
      }
      window.reorderGroups(true, 2);
    };

    var update = function (redraw = false, reset = true) {
      BatchGeo.timer("legend update() redraw: " + redraw + ", reset: " + reset);
      // elem.html('').show();

      legendFilteredMarkers = {};
      var uniqueColumns = {};
      window.per.legend_columns =
        window.batchGeoGoogleMapsMarker.MarkerLegend.getColumns();
      for (var i = 0; i < filters.length; i++) {
        for (var c in filters[i].markers) {
          if (filters[i].markers[c] === null) continue;
          legendFilteredMarkers[c] = legendFilteredMarkers[c] || {};
          legendFilteredMarkers[c][filters[i].column] = true; // add one for every filter
        }
        uniqueColumns[filters[i].column] = true;
      }

      // how many filter columns
      var uniqueCount = Object.size(uniqueColumns);
      for (var r in legendFilteredMarkers)
        if (Object.size(legendFilteredMarkers[r]) < uniqueCount)
          // only passes at least once in every filter column
          delete legendFilteredMarkers[r];

      if (self.getMarkerGroupsArray().length > 1 || filters.length) {
        filterColumns(true);

        // TODO: When updating the columnList & groupList UI
        // we should check against self.options.markersData.dataRS or self.options.markersData.mapRS
        // to see which options are still applicable given
        // the currently selected filters.

        updateColumnName();
        updateColumnList();
        updateGroupList();

        var limit = window.batchGeoGoogleMapsMarker.limit;
        // var temp_start = window.batchGeoGoogleMapsMarker.startValue;
        var temp_stop = window.batchGeoGoogleMapsMarker.stopValue;
        var list_button = $('<button class="listButton">');
        var list_back_button = $('<button class="listBackButton">');
        var back_button_box = $('<div class="buttonbox">');
        var forward_button_box = $('<div class="buttonboxforward">');

        // var placeholder = $('<div class="placeholder">');

        back_button_box.css({
          "grid-column": "1/3",
          "grid-row": "1/2",
          cursor: "pointer",
        });

        forward_button_box.css({
          "grid-column": "4/5",
          "grid-row": "1/2",
        });

        list_back_button.click(moveBackward);

        if (
          window.batchGeoGoogleMapsMarker.startValue >
          window.batchGeoGoogleMapsMarker.markerScaler - 1
        ) {
          back_button_box.append(list_back_button);
          let targetItem = $("ul.groupList").children().first();
          targetItem.append(back_button_box);
        }

        forward_button_box.click(moveForward);

        if (
          limit > window.batchGeoGoogleMapsMarker.markerScaler - 1 &&
          temp_stop !== limit
        ) {
          forward_button_box.append(list_button);
          let targetItem = $("ul").children("li#targetItem");
          targetItem.append(forward_button_box);
        }
      } else if (redraw) {
        hideWrap();
      }

      wrap.toggle(wrap.text().trim().length !== 0);

      BatchGeoStore.dispatch({
        type: "MARKER_LEGEND_SET_FILTERS",
        filters: filters,
        update: false,
      });

      updateFilterList();

      if (redraw) {
        BatchGeoStore.getState().MarkerDrawer.shouldDraw = true;
        self.MarkerDrawer.draw();
        if (self.getMarkerGroupsArray().length > 1 || filters.length)
          resizeWrap();
      }
      window.reorderGroups(true, 3);

      updateActiveMarkerIcon(redraw);
      syncFilterAndSelectedMarkers();
      updatePolylineColors();

      if (window.per.group_by_sel === -1 && !window.per.dist_cb_status) {
        wrap?.hide();
      }

      return legendFilteredMarkers;
    };

    function getSharedValues(arrays) {
      if (arrays.length < 1) return;
      const obj = {};
      const result = [];

      // Loop through the first array and add its elements to the object
      for (let i = 0; i < arrays[0].length; i++) {
        obj[parseInt(arrays[0][i])] = 1;
      }

      // Loop through the remaining arrays and their elements
      for (let i = 1; i < arrays.length; i++) {
        const currentArray = arrays[i];

        for (let j = 0; j < currentArray.length; j++) {
          const currentValue = parseInt(currentArray[j]);

          if (obj[currentValue] === i) {
            obj[currentValue]++;
          }
        }
      }

      // Loop through the keys in the object and add them to the result array if their count is equal to the number of input arrays
      for (const key in obj) {
        if (obj[key] === arrays.length) {
          result.push(parseInt(key));
        }
      }

      return result;
    }

    var createFilter = function (column_, group_, markers_, isSearch = false) {
      filters.push({ column: column_, group: group_, markers: markers_ });
      if (isSearch) {
        self.MarkerGroups.colorObjectsInUse.push({
          location: -1,
          column: column_,
        });
      }
    };

    var removeFilter = function (column_, group_) {
      for (var i = 0; i < filters.length; i++)
        if (filters[i].column == column_ && filters[i].group == group_)
          filters.splice(i, 1);
    };

    var columnIsAssigned = function (columnIndex) {
      var assignedToOther = false;

      var groupBy = self.options.markersData.group_col;
      var assigned = [
        self.options.markersData.lat_col,
        self.options.markersData.long_col,
        self.options.markersData.postal_col,
        self.options.markersData.columnNames.indexOf(window.accuracy_name),
        self.options.markersData.address_col,
        self.options.markersData.city_col,
        self.options.markersData.state_col,
        self.options.markersData.zip_col,
        self.options.markersData.descURL_col,
        self.options.markersData.descIMG_col,
        self.options.markersData.email_col,
        self.options.markersData.desc_col,
        self.options.markersData.country_col,
      ];

      for (var key in assigned) {
        var assignedIndex = assigned[key];
        // Check if the columnIndex is on the assigned list AND checks if it has been selected
        // as the Group By selection to allow that to be included in the filterList
        if (assignedIndex === columnIndex && columnIndex !== groupBy) {
          assignedToOther = true;
        }
      }

      return assignedToOther;
    };

    function selectPreviousColumn(redraw) {
      selectColumn(previousSelectedColumnIndex, redraw);
    }

    var getFilteredMarkers = function () {
      return legendFilteredMarkers;
    };

    var clearFilters = function () {
      filters = [];
      self.MarkerGroups.colorIndiciesInUse = [];
      self.MarkerGroups.colorObjectsInUse = [];
      self.MarkerGroups.filterGroups = [];
      self.MarkerGroups.heatFilterGroups = [];
      self.MarkerGroups.heatColorObjectsInUse = [];
      update(true);
      updateActiveMarkerIcon(true, true);
      resizeWrap();
      updatePolylineColors();
    };

    var exportFilters = function () {
      // exports filters to string for passing into URLs and such, removes markers component which can get large
      var _filter = [];
      for (var i = 0; i < filters.length; i++) {
        _filter[i] = { column: filters[i].column, group: filters[i].group };
      }
      return _filter;
    };

    var importFilters = function (_filters) {
      // lets load filters from this array
      var originalColumn = self.options.markersData.group_col;
      for (var i = 0; i < _filters.length; i++) {
        var _column = self.options.markersData.columnNames.indexOf(
          _filters[i].column,
        );
        if (_column >= 0) {
          if (_column !== window.per.group_col) {
            selectColumn(_column, true);
          }

          var group = groups.indexOf(_filters[i].group);
          if (group >= 0) {
            // select the group, will populate filter vars
            selectGroup(_filters[i].group, true);
          }
        }
      }
      selectColumn(originalColumn); // return map to whatever column was originally selected
      update(true, false); // redraw map but dont change zoom
    };

    var getColumn = function () {
      return column;
    };

    var getColumns = function () {
      return columns;
    };

    var getFilters = function () {
      return filters;
    };

    var setFilters = function (filtersList) {
      if (filtersList) {
        filters = filtersList;
        update(false);
      }
    };

    /**
     * If there are markers selected this will render a label in the legend
     * with the total number. i.e. "1 location selected" or "2 locations
     * selected". If no markers are selected it will remove the label.
     *
     * @param {{selection: Array<Number>}} selectionState This is expecting
     * a redux "next" state for DrawingManager which means an array of marker
     * IDs like `{selection: [1, 9, 93]}`.
     */
    var updateSelectedMarkerCount = function (selectionState) {
      const count = selectionState.selection.length;
      const isMobile = BatchGeoDevices.is("mobile");
      selectedCountEl.html(
        $("<span />", {
          toggle: count > 0 && !isMobile,
          html: [
            $("<img />", {
              src: `/images/noun-select-all.svg`,
              class: "selectIndicatorSVG",
            }),
            $("<p />", {
              text: `${BatchGeo.pluralize(count, "Location")}`,
            }),
          ],
        }),
      );

      window.reorderGroups(true, 6);

      // check if element is on dom
      if (!$("#mapDiv .selected-marker-count").length) {
        mapDiv.append(selectedCountEl);
      }

      const windowWidth = window.innerWidth;
      const hasSpecialClass = selectedCountEl.hasClass("smc-up");
      if (count > 1 && windowWidth >= 600 && windowWidth <= 800) {
        if (!hasSpecialClass) {
          selectedCountEl.addClass("smc-up");
        }
      } else {
        if (hasSpecialClass) {
          selectedCountEl.removeClass("smc-up");
        }
      }
    };

    BatchGeoStore.addListener(
      "MarkerLegend",
      function (newState, oldState) {
        return (
          (newState.shouldUpdate && newState.filters !== oldState.filters) ||
          (newState.shouldUpdate && !oldState.shouldUpdate)
        );
      },
      function () {
        BatchGeoStore.dispatch({ type: "MARKER_LEGEND_RESET_UPDATE" });
        update(true, false);
      },
    );

    BatchGeoStore.addListener(
      function (state) {
        return state;
      },
      function (newState, oldState) {
        return (
          newState.MapsManager.rendered !== oldState.MapsManager.rendered ||
          newState.BatchGeoTableMap.mapHeights.mapWrap !==
            oldState.BatchGeoTableMap.mapHeights.mapWrap
        );
      },
      function () {
        resizeColumnListHeight();
      },
    );

    /**
     * This listener listens for filter changes and then updates the search
     * results that display below the filters.
     */
    BatchGeoStore.addListener("MarkerLegend", "filters", updateFilterResults);
    BatchGeoStore.addListener(
      "DrawingManager",
      "selection",
      updateSelectedMarkerCount,
    );
    BatchGeoStore.addListener(
      "DrawingManager",
      "selection",
      updateActiveMarkerIcon,
    );
    BatchGeoStore.addListener(
      "MarkerLegend",
      "filters",
      updateActiveMarkerIcon,
    );

    BatchGeoStore.addListener(
      function (state) {
        return state.RowSelect.selection;
      },
      function (nextSelectedRows, prevSelectedRows) {
        return nextSelectedRows.toString() != prevSelectedRows.toString();
      },
      function (newRows) {
        // exclude any rows that don't have a corresponding marker to select on map view
        const newRowsSansOutliers = newRows.filter(
          (id) => window.per.mapRS[id].accuracy !== "unknown",
        );
        updateSelectedMarkerCount({ selection: newRowsSansOutliers });
      },
    );

    // Public API
    self.MarkerLegend = {
      update: update,
      updateSelectedMarkerCount: updateSelectedMarkerCount,
      updatePolylineColors: updatePolylineColors,
      hide: hideWrap,
      filterColumns: filterColumns,
      filterExists: filterExists,
      resize: resizeWrap,
      columnIsAssigned: columnIsAssigned,
      selectColumn: selectColumn,
      selectPreviousColumn: selectPreviousColumn,
      selectGroup: selectGroup,
      createFilter: createFilter,
      removeFilter: removeFilter,
      clearFilters: clearFilters,
      importFilters: importFilters,
      getFilteredMarkers: getFilteredMarkers,
      getColumn: getColumn,
      getColumns: getColumns,
      updateGroupList: updateGroupList,
      updateColumnList: updateColumnList,
      getFilters: getFilters,
      setFilters: setFilters,
      exportFilters: exportFilters,
      getDelay: getDelay,
      getTimeoutValue: getTimeoutValue,
      setTimeoutValue: setTimeoutValue,
      getMetricValue: getMetricValue,
      setMetricValue: setMetricValue,
      moveBackward: moveBackward,
      moveForward: moveForward,
      isActive: isActive,
    };
  };

  window.MarkerLegend = MarkerLegend;
})(window);
